import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 首页
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
  // 关于我们
  {
    path: "/contactUs",
    name: "contactUs",
    component: () => import("@/views/contactUs.vue"),
  },
  // 新闻中心
  {
    path: "/newsCenter",
    name: "newsCenter",
    component: () => import("@/views/newsCenter.vue"),
  },
  // 新闻中心详情
  {
    path: "/newsCenterDetails",
    name: "newsCenterDetails",
    component: () => import("@/views/newsCenterDetails.vue"),
  },
  // 项目合作
  {
    path: "/projectCooperation",
    name: "projectCooperation",
    component: () => import("@/views/projectCooperation.vue"),
  },
  // 项目合作详情
  {
    path: "/projectCooperationDetails",
    name: "projectCooperationDetails",
    component: () => import("@/views/projectCooperationDetails.vue"),
  },
  // 走进厚宇
  {
    path: "/comeHouyu",
    name: "comeHouyu",
    component: () => import("@/views/comeHouyu.vue"),
  },
  // 产品中心
  {
    path: "/productCenter",
    name: "productCenter",
    component: () => import("@/views/productCenter.vue"),
  },
  // 产品中心详情
  {
    path: "/productCenterDetails",
    name: "productCenterDetails",
    component: () => import("@/views/productCenterDetails.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
